import React from 'react';
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

// Animation configuration
const navItemVariants = {
  hover: { scale: 1.1, y: -5 },
  tap: { scale: 0.95 },
  active: { color: "#fff" }
};

const BottomNav = () => {
  // Nav items configuration
  const navItems = [
    { to: "/", icon: "icofont-ui-home", label: "الرئيسية" },
    { to: "/members", icon: "icofont-people", label: "الأعضاء" },
    { to: "/blog", icon: "icofont-pen", label: " مدونة الزواج" },
    { to: "/success-story", icon: "icofont-book", label: "  قصص نجاح" },
    { to: "/subscriptions", icon: "icofont-star", label: "باقات التميز" }
  ];

  return (
    <div className="d-lg-none">
      <nav 
        className="navbar fixed-bottom p-2" 
        style={{ 
          backgroundColor: "#391965",
          boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)"
        }}
      >
        <div className="container-fluid">
          <div className="row w-100 d-flex justify-content-evenly">
            {navItems.map((item, index) => (
              <div key={index} className="col-2 text-center">
                <motion.div
                  whileHover="hover"
                  whileTap="tap"
                  className="h-100 d-flex flex-column justify-content-center"
                >
                  <NavLink
                    to={item.to}
                    className={({ isActive }) => 
                      `text-decoration-none ${isActive ? "active" : ""}`
                    }
                  >
                    {({ isActive }) => (
                      <div className="position-relative d-flex flex-column justify-content-center">
                        <motion.i
                          className={`${item.icon} fs-3 d-block ${isActive ? "text-danger":"text-warning"}`}
                          variants={navItemVariants}
                          animate={isActive ? "active" : ""}
                         
                        />
                        <motion.small
                          className="d-block"
                          variants={navItemVariants}
                          animate={isActive ? "active" : ""}
                          style={{ 
                            color: isActive ? "#fff" : "#a982d6",
                            fontSize: "0.70rem",
                            textWrap:"nowrap"
                          }}
                        >
                          {item.label}
                        </motion.small>
                        
                       
                      </div>
                    )}
                  </NavLink>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default BottomNav;